import { render } from "./ProjectsToInvoice.vue?vue&type=template&id=72b84fe6&ts=true"
import script from "./ProjectsToInvoice.vue?vue&type=script&lang=ts"
export * from "./ProjectsToInvoice.vue?vue&type=script&lang=ts"

import "./ProjectsToInvoice.vue?vue&type=style&index=0&id=72b84fe6&lang=scss"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__